import { useTheme } from '@mui/material';

import { WithRef } from '../../../types';
import { getThemeColor } from '../../../utils';
import IconBase, { CastProductIconProps } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#e64a19';

export const CastPrometheusRounded = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const theme = useTheme();
  const isPreset = variant === 'preset';
  const fillColor = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : getThemeColor(theme, color);

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 48 48"
      fill="none"
    >
      <circle cx="24" cy="24" r="20" fill={fillColor} />
      <path
        fill="#fff"
        d="M29.91,37c-0.47,2.84-2.94,5-5.91,5s-5.44-2.16-5.91-5H29.91z M34,32H14v3h20V32z M33.5,30 c1-1,2.5-3.5,3-5C35,25.5,30,26.5,30,26.5c1-1.5,2-3.5,2-6c0-3.5-4-7-3-11.5c-2.5,2.5-2.5,7.5-2.5,9.5c-0.5-1.5-0.5-3-0.5-4 c0-3-3-5.5-2-8.5c0,0-2.5,1-2.5,4c0,3.5-0.5,5.5-1.5,6.5c0-3-1-5-2.5-5.5c0.5,1,0.5,1.5,0.5,2c0,1.5-2.5,6-2.5,9c0,2,1,3.5,2.5,4.5 c0,0-4-1-6.5-1.5c0.5,1.5,2,4,3,5C14.5,30,31.5,30,33.5,30z"
      />
    </IconBase>
  );
};

CastPrometheusRounded.displayName = 'CastPrometheusRounded';
